<template>
  <v-card
    outlined
    v-if="!dontShowFolder.includes(folderData.itemName) && (!folderData.hidden || isAdmin)" 
    :class="{
      'strategio-hidden-item': folderData.hidden,
      'elevation-9': folderData.isMoving
    }" 
    :style="[
      {'width': '234px'},
      {'height': '193px'},
      {'margin': '20px'},
      {'background-color': '#FFFFFF'},
      {'border': '1px solid rgba(0, 0, 0, 0.05)'},
      {'border-radius': '10px'},
      {'padding': '25px'},
    ]"
    class="d-flex flex-column justify-center"
    @click="enterFolder(folderData.itemID)"
  >
    <div
      class="d-flex align-center"
      style="position: absolute; right: 9px; top: 13px;"
    >
      <item-menu :item="folderData" v-if="isAdmin" :is-searching="isSearching"></item-menu>       
    </div>

    <!-- <v-img
      :src="require('@/assets/icon-folder.svg')"
      height="50"
      width="50"
    ></v-img> -->

    <v-icon
      class="folder-list-item-icon"
      size="39.17px"
      color="rgba(37, 35, 95, 1)"
    >
      ico-icon-folder
    </v-icon>

    <div
      class="strategio-folder-card-title"
      style="margin-top: 15px"
    >
      {{folderData.itemName}}
    </div>

    <div
      class="strategio-folder-card-subtitle"
      style="margin-top: 10px"
    >
      {{folderData.childrenCount}} Reportes
    </div>

    <div
      class="strategio-folder-text-button d-flex align-center"
    >
      Ver archivos
      <v-icon class="strategio-folder-text-button-icon" color="#23A2D9" size="12px">ico-icon-right</v-icon>
    </div>
  </v-card>
</template>

<script>
import {find, flatMap, reduceRight, partition} from 'lodash'

import ItemMenu from '../menus/item-menu.vue'
import userStorage from '../../storage/userStorage'
import eventBus from '../../utils/eventBus'
import reportsStorage from '../../storage/reportsStorage'
import structureStorage from '../../storage/structureStorage'

export default {
  name: 'folder-list-item',
  data () {
    const user = userStorage.getUserInfo()
    return {
      isFavorite: false,
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      test: [],
      dontShowFolder: [
        'download-cube'
      ]
    }
  },
  computed: {
    partitionedChildren () {
      let [isFolder, isReport] = partition(this.folderData.children, (child) => child.isFolder)
      return {
        folders: {
          list: isFolder || []
        },
        reports: {
          list: isReport || []
        }
      }
    }
  },
  methods: {
    getFolderSize () {
      return this.$vuetify.breakpoint.name === 'xs' ? '85%' : '220px'
    },
    getAlphaedColor (hrgba) {
      const hexToRGBA = (hrgba) => {
        let prgba = (hrgba.charAt(0) === '#') ? hrgba.substring(1, 9) : hrgba
        return {
          r: parseInt(prgba.substring(0, 2), 16),
          g: parseInt(prgba.substring(2, 4), 16),
          b: parseInt(prgba.substring(4, 6), 16),
          a: parseInt(prgba.substring(6, 8), 16) / 255
        }
      }
      return `rgba(${[Object.values(hexToRGBA(hrgba))].join(', ')})`
    },
    isNestedHeredable () {
      // eslint-disable-next-line
      return !(this.folderData.containedBy == this.$route.params.folderID)
    },
    getParentFolderName (_itemID) {
      let temp = ''
      structureStorage.getHeritableItems({
        onSuccess: (items) => {
          temp = find(items, ({itemID}) => itemID === _itemID).itemName
        }
      })
      return temp
    },
    /* getParentFolder (item) {
      let temp = {}
      structureStorage.getHeritableItems({
        onSuccess: (items) => {
          temp = find(items, ({itemID}) => itemID === item.containedBy)
        }
      })
      return temp
    }, */
    getParentFolder (item, folders) {
      let _folders = folders || [item]

      structureStorage.getHeritableItems({
        onSuccess: (items) => {
          let itemIntent = find(items, ({itemID}) => itemID === item.containedBy)
          if (itemIntent) {
            _folders.push(itemIntent)
            this.getParentFolder(itemIntent, _folders)
          }
        }
      })
      return _folders
    },
    getParentFoldersNames (item) {
      return reduceRight(flatMap(this.getParentFolder(item), 'itemName'), (total, item) => {
        return `${total} > ${item}`
      })
    },
    enterFolder (folderID) {
      // eslint-disable-next-line
      if (folderID == this.$route.params.folderID) {
        eventBus.$emit('reload-items', {})
      } else {
        this.$router.push({name: 'MainPage', params: {folderID}})
      }
    },
    showReport (data) {
      if (data.url1.trim() === '') {
        // descargar si hay url2
        if (data.url2.trim() === '') {
          // descargar reporte y notificar
          eventBus.$emit('open-custom-snack-bar', {message: 'No hay URL de visualización ni de descarga', itsOk: 'warning'})
        } else {
          // Notificar que no hay url de visualizacion ni descarga
          window.open(data.url2, '_blank')
          reportsStorage.registerView(data.itemID, 'DOWNLOAD')
          eventBus.$emit('open-custom-snack-bar', {message: 'No hay URL de visualización. Descargando reporte', itsOk: 'warning'})
        }
      } else {
        let _isFavorite = ''
        if (this.$route.name === 'Favorites') {
          _isFavorite = '/1'
        }
        this.$router.push(`/show-report/${data.itemID}${_isFavorite}`)
      }
    }
  },
  components: {
    ItemMenu
  },
  props: {
    folderData: {
      type: Object,
      default () {
        return {}
      }
    },
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    toUpdate: {
      type: Object,
      default () {
        return {}
      }
    },
    toUpdateOn: {
      type: Boolean,
      default () {
        return false
      }
    },
    colorTheme: {
      type: Object,
      default () {
        return {
          background: 'lightgray',
          text: 'black'
        }
      }
    },
    addInnerFolder: {
      type: Function,
      default () {
        return () => {}
      }
    },
    addInnerReport: {
      type: Function,
      default () {
        return () => {}
      }
    },
    manageInnerReportsPermissions: {
      type: Function,
      default () {
        return () => {}
      }
    }
  }
}
</script>
<style>
.folder-list-item-icon {
  height: 35.25px;
  width: 39.16px;
  border-radius: 0px;
  -webkit-text-stroke: 0.3px #25235F;
}

.strategio-folder-card-nested-title {
  padding: 2px 14px 0px 16px;
  font-size: 12px;
  font-weight: 300;
  color: rgb(17, 66, 116);
  width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}
.strategio-folder-card-title {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 24px;
  color: #25235F;
  -webkit-text-stroke: 0.3px #25235F;
}
.strategio-folder-card-subtitle {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}
.strategio-folder-text-button {
  margin-top: 11px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: #23A2D9;
  text-transform: none;
}

.strategio-folder-text-button-icon {
  margin-left: 7px;
  -webkit-text-stroke: 0.3px #23A2D9;
}

</style>



// WEBPACK FOOTER //
// src/components/folders/folder-list-item.vue